import { useEffect, useState } from 'react';
import { emptyFavorites, FAVORITES_EVENT, FAVORITES_KEY, readFavorites, updateFavorites, VisitorFavorites } from '../utils/visitorFavorites';
import { useContent } from '../contexts/ContentContext';
import { useScore } from './useScore';

export function useVisitorFavorites() {
    const { t } = useContent();
    const { sendAction } = useScore();
    const [data, setData] = useState(emptyFavorites);
    const [error, setError] = useState<'' | 'read' | 'write' | 'nameLength' | 'duplicate' | 'stale'>('');
    const [readable, setReadable] = useState(false);
    useEffect(() => {
        const refresh = () => {
            try { setData(readFavorites()); setReadable(true); setError(''); }
            catch { setReadable(false); setError('read'); }
        };
        const storage = (event: StorageEvent) => { if (event.key === FAVORITES_KEY || event.key === null) refresh(); };
        refresh();
        window.addEventListener('storage', storage);
        window.addEventListener(FAVORITES_EVENT, refresh);
        return () => { window.removeEventListener('storage', storage); window.removeEventListener(FAVORITES_EVENT, refresh); };
    }, []);
    const change = (edit: (value: VisitorFavorites) => void): boolean => {
        try {
            let addedIds: number[] = [];
            const next = updateFavorites(value => {
                const previous = new Set(value.images.map(item => item.id));
                edit(value);
                addedIds = value.images.filter(item => !previous.has(item.id)).map(item => item.id);
            });
            setData(next); setReadable(true); setError('');
            addedIds.forEach(id => { void sendAction(String(id), 'bookmark'); });
            return true;
        }
        catch (err) {
            const code = err instanceof Error ? err.message : '';
            setError(code === 'nameLength' || code === 'duplicate' || code === 'stale' ? code : 'write');
            return false;
        }
    };
    return { data, error: error ? t(`favoriteErrors.${error}`) : '', readable, change };
}
